// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"77":"fdde85e5","299":"69a8d4cc","544":"d4139ab1"}[chunkId] + ".chunk.css";
};